import { HostConfig } from 'features/home/types'

export const hasSysMonSupport = ({ hostCapabilities }: HostConfig) => {
  return (hostCapabilities || []).reduce((acc, { type, version, enabled }) => {
    return acc
      ? acc
      : type === 'remoteDealerInterface' && !!enabled && version >= 1
  }, false)
}
